module.exports = __webpack_public_path__ + "img/peh33_reset.239d9c46.png";